import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS,
} = documentationActions;

function* getAllMiscellaneousDocuments(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS });
    const response = yield call(templateService.getAllMiscellaneousDocuments, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS, payload: error });
  }
}

function* getAllMiscellaneousDocumentsSaga() {
  yield takeEvery(REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS, getAllMiscellaneousDocuments);
}

export default getAllMiscellaneousDocumentsSaga;
